const conf={
    dataServer: process.env.NODE_ENV==='production'?"ws://www.shangzai.com/ws":'ws://localhost:8080',
    calcServer: process.env.NODE_ENV==='production'?"ws://www.shangzai.com/calcWs":'ws://localhost:8079'
}
module.exports = conf
